import AllView from './all';
import { DataReq } from './view';
import api from '@/services/billing';
import Pivot from '..';
import ShippingExpand from './shipping/expand.vue';
import { Order } from '@/models/order';
import { Package } from '@/models/package';

export default class IView extends AllView {
  public Name = 'shipping';

  public async Data(req: DataReq) {
    if (!req.sources) {
      req.sources = ['order'];
    }
    req.filter = {
      condition: 'and',
      rules: [
        {
          condition: 'or',
          rules: [
            {
              condition: 'and',
              rules: [{
                key: 'release_without_payment',
                operator: '=',
                value: 1
              }, {
                key: 'state',
                operator: '=',
                value: 'APPROVED'
              }]
            },
            {
              key: 'state',
              operator: '=',
              value: 'PAID'
            }
          ]
        },
        req.filter
      ]
    };
    const data = await api.ListPivotAll(req);
    const res: any = [];
    for (const d of data) {
      d.ob.object_type = d.object_type;
      res.push(d.ob);
    }
    return res;
  }

  public Filter(v: any) {
    return (v.packages && v.packages.find((p: Package) => p && p.shippable)) ? true : false;
  }

  public get Headers(): any {
    return [
      ...super.Headers,
      {
        name: 'expand_shipping',
        datasources: ['invoice', 'order'],
        type: "more",
        text: "More",
        value: "id",
        sortable: false,
        width: 10,
        expand: {
          name: 'expand-shipping',
          component: (row: any) => ShippingExpand,
          props: (row: any) => ({
            Order: row,
          })
        }
      }
    ];
  }

  public get Actions(): any {
    return [];
  }
}
